import { notification } from 'antd'
import {
  listAllAbstractUrl,
  deleteAbstractUrl,
  addAbstractUrl,
  updateAbstractUrl
} from '../apis'
import { getToken, customAxios as axios } from '../../../request'
import { hidePageLoad, showPageLoad } from '../../../modules/actions'

/**
 * LIST ABSTRACTS
 */
export const listAllAbstract = async (filters) => {
  let config = {
    params: { ...filters },
    ...getToken()
  }

  let { data } = await axios.get(listAllAbstractUrl(), config)

  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }

  return data
}

/**
 * ADD ABSTRACT
 */
export const addAbstractFxn = async (valData) => {
  let config = {
    ...getToken()
  }

  let { data } = await axios.post(addAbstractUrl(), valData, config)

  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }

  return data
}
export const deleteAbstractFxn = async (id) => {
  let config = {
    ...getToken()
  }

  let { data } = await axios.post(deleteAbstractUrl(), { abstractId: id }, config)

  if (data.error) {
    notification.error({
      message: data.message || 'Error deleting abstract'
    })
  }

  return data
}
export const updateAbstractFxn = (valData) => async (dispatch) => {
  let config = {
    ...getToken()
  }
  let { data } = await axios.post(updateAbstractUrl(), valData, config)

  return data
}